var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"icon12","stroke":"#858585"},React.createElement("polygon",{"id":"Shape","points":"10 21 10 15 14 15 14 21 19 21 19 13 22 13 12 4 2 13 5 13 5 21"}))));
}

Home.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Home;

Home.default = Home;
